import css from 'styled-jsx/css';

const styles = css.global`#leilao-de-veiculos-datas {
    background: #F5F9FB;
    padding: 48px 0;
    position: relative;
}

#leilao-de-veiculos-datas .img-datas {
    position: absolute;
    top: 0;
    right: 0;
}

#leilao-de-veiculos-datas .leilao-de-veiculos-datas-titulo {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
}

#leilao-de-veiculos-datas .leilao-de-veiculos-datas-texto {
    margin-top: 8px;
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#leilao-de-veiculos-datas .dropdown {
    margin-top: 24px;
    margin-bottom: 0;
    height: 48px;
    border-radius: 4px;
    border: 1px solid #444;
    width: 100%;
    max-width: 280px;
}

#leilao-de-veiculos-datas .dropdown .selected-value input {
    color: #444;
    font-size: 18px;
    font-style: normal;
    line-height: 28px;
}

/* #leilao-de-veiculos-datas .dropdown .selected-value input::placeholder {
    color: red;
    position: absolute;
    top: -15px;
} */

#leilao-de-veiculos-datas .dropdown .option {
    font-size: 18px;
}

#leilao-de-veiculos-datas .dropdown .arrow {
    background-image: url(assets/leilao-de-veiculos/ic-arrow-dropdown.svg);
    width: 24px;
    height: 24px;
    margin: 0;
    border-color: transparent;
    border-style: none;
    border-width: 0;
    right: 16px;
    top: 10px;
    transition: 0.3s ease-out;
}

#leilao-de-veiculos-datas .dropdown .arrow.open {
    transform: rotate(180deg);
    transition: 0.1s ease-out;
}

#leilao-de-veiculos-datas .datas-cidades {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 24px;
}

#leilao-de-veiculos-datas .datas-cidades-titulo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
}

#leilao-de-veiculos-datas .datas-cidades-titulo b {
    color: #C00;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
}

#leilao-de-veiculos-datas .datas-cidades-endereco {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

#leilao-de-veiculos-datas .datas-cidades-endereco a {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
}

#leilao-de-veiculos-datas .datas-cidades-endereco a:hover {
    color: #C00;
}

@media (min-width: 992px) {
    #leilao-de-veiculos-datas .ctn-home-24 {
        display: flex;
        align-items: flex-start;
    }

    #leilao-de-veiculos-datas .img-datas {
        position: initial;
        margin-top: -48px;
        margin-left: -124px;
        margin-bottom: -140px;
    }

    #leilao-de-veiculos-datas .leilao-de-veiculos-datas-titulo {
        font-size: 40px;
        line-height: 60px;
    }
    
    #leilao-de-veiculos-datas .leilao-de-veiculos-datas-texto {
        line-height: 150%;
        max-width: 742px;
    }

    #leilao-de-veiculos-datas .dropdown {
        margin-bottom: -2px;
    }

    #leilao-de-veiculos-datas .datas-cidades {
        padding-bottom: 15px;
        max-width: 742px;
    }
}`;

export default styles;